import React, { useState } from 'react';
import { Modal, IconButton, Box } from '@mui/material';
import Close from '@mui/icons-material/Close';

import {
  GuideModalContainer,
  GuideModalHeader,
  GuideModalHeaderTitle,
  GuideModalBody,
  GuideSection,
  GuideSectionLabel,
  GuideText,
  GuideDivider,
} from '../../../lesson/groupLesson/GroupLessonStyled';

const TABS = [
  { key: 'overview', label: '수강권이란?' },
  { key: 'fields', label: '등록 항목' },
  { key: 'usage', label: '차감·유효기간·정지' },
  { key: 'refund', label: '환불·양도·주의사항' },
];

const OverviewGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>🎟️ 수강권이란?</GuideSectionLabel>
      <GuideText>
        그룹수업·개인레슨(듀엣레슨 포함)에서 사용하는 <strong>횟수제 상품</strong>입니다.<br />
        정해진 횟수만큼 수업을 예약해서 들을 수 있는 이용권이라고 생각하면 됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🆚 이용권(패스)과의 차이</GuideSectionLabel>
      <GuideText>
        • 수강권은 <strong>특정 수업을 예약</strong>해서 듣는 상품입니다. 담당 강사를 지정하거나 커리큘럼을 붙일 수 있습니다.<br />
        • 이용권(패스)은 예약 없이 <strong>자유롭게 출입</strong>하는 자유이용형 상품입니다.<br />
        • 기간 동안 무제한으로 쓰는 <strong>정액권 개념은 수강권에 없습니다.</strong> 정액형 상품은 "이용권"에서 만듭니다. 수강권은 항상 <strong>횟수 기반</strong>입니다.
      </GuideText>
    </GuideSection>
  </>
);

const FieldsGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>➕ 등록 시 입력 항목</GuideSectionLabel>
      <GuideText>
        • <strong>수업유형</strong> — 그룹레슨/개인레슨/듀엣레슨/온라인레슨 등. <strong>등록 후에는 수정 화면에서 바꿀 수 없습니다.</strong> (유일하게 잠기는 항목)<br />
        • <strong>수강권명, 판매지점/이용지점</strong> — 여러 지점이 함께 쓰는 상품으로 설정할 수 있습니다. "구매한 지점만 이용" 체크 시 다른 지점에서는 사용할 수 없습니다.<br />
        • <strong>운동종목</strong>(복수 선택 가능), <strong>앱 노출 여부</strong>
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⏱️ 이용 설정</GuideSectionLabel>
      <GuideText>
        • <strong>이용기간</strong> — 개월 또는 일 단위로 설정<br />
        • <strong>이용횟수</strong> — 총 몇 회까지 이용 가능한지<br />
        • <strong>수업시간(분)</strong><br />
        • <strong>중지권</strong> — 무제한 / 중지 불가 / 직접입력(정지 가능 횟수 + 정지 가능 일수)<br />
        • <strong>일일·주간 이용제한, 최대예약권, 예약취소권</strong><br />
        • <strong>요일·시간대 제한</strong> — 주로 개인레슨·듀엣레슨에서 사용
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>💰 가격·이미지</GuideSectionLabel>
      <GuideText>
        • 정가, 할인금액, 최종 결제금액, 판매기간, 할인기간<br />
        • 이미지 최대 7장, 커리큘럼 최대 5개
      </GuideText>
    </GuideSection>
  </>
);

const UsageGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>➖ 차감 방식</GuideSectionLabel>
      <GuideText>
        • 수업 1회당 차감되는 횟수는 그룹수업/개인레슨 <strong>등록 시 설정</strong>합니다(기본값 1회).<br />
        • <strong style={{ color: '#EE753A' }}>회원이 "출석"해도 "결석"해도 동일하게 차감됩니다.</strong> 결석했다고 차감이 면제되지 않습니다.<br />
        • 예약을 <strong>취소</strong>한 경우에는 차감되지 않습니다.<br />
        • 총 이용횟수를 모두 소진하면 자동으로 <strong>사용 종료(비활성)</strong> 상태가 됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>📅 유효기간</GuideSectionLabel>
      <GuideText>
        • 이용기간(개월/일)을 기준으로 계산됩니다.<br />
        • 시작일을 따로 지정하지 않으면 <strong>판매(등록)일이 시작일</strong>이 되고, <strong>만료일 = 시작일 + 이용기간 − 1일</strong>입니다.<br />
        • 회원에게 배정할 때 관리자가 시작일을 미래 날짜로 직접 지정할 수도 있습니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⏸️ 정지(홀딩)</GuideSectionLabel>
      <GuideText>
        • <strong>정지 가능 횟수</strong>와 <strong>정지 가능 일수</strong>가 각각 따로 관리됩니다.<br />
        • 정지하면 정지 기간만큼 <strong>만료일이 뒤로 밀립니다</strong>(이용횟수는 줄어들지 않습니다).<br />
        • 정지를 해제하면 남은 일수만큼 다시 당겨집니다.
      </GuideText>
    </GuideSection>
  </>
);

const RefundGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>💸 환불</GuideSectionLabel>
      <GuideText>
        • 환불금액은 <strong>시스템이 자동 계산해주지 않습니다.</strong> "이용금액"(기본값 = 회당요금 × 사용횟수)과 "위약금"을 관리자가 직접 입력/수정하면, <strong>환불금액 = 결제금액 − (이용금액 + 위약금)</strong>으로 자동 계산되어 표시됩니다(0원 미만으로는 내려가지 않음). 값을 정확히 입력하는 것이 중요합니다.<br />
        • 환불된 수강권은 상태가 "환불"이 아니라 <strong style={{ color: '#EE753A' }}>"비활성(사용안함)"</strong>으로 표시됩니다. 화면만 봐서는 다 써서 끝난 건지 환불된 건지 구분되지 않으니, 환불 여부는 결제/환불 내역에서 별도로 확인해야 합니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🔄 양도</GuideSectionLabel>
      <GuideText>
        • <strong>사용중(ACTIVE)</strong> 상태의 수강권만 양도할 수 있습니다.<br />
        • 아직 끝나지 않은 예약이 있으면 양도할 수 없습니다. 본인에게는 양도할 수 없습니다.<br />
        • 양도하면 <strong>잔여횟수와 만료일은 그대로 유지</strong>되고, 시작일만 양도일로 재설정됩니다.<br />
        • 양도 수수료는 선택사항입니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⚠️ 주의사항</GuideSectionLabel>
      <GuideText>
        • 이미 판매된 수강권도 이용횟수·기간 등을 수정 화면에서 <strong>제한 없이 바꿀 수 있습니다</strong>(잠기는 항목은 수업유형뿐). 실수로 회원 보유 수량에 영향을 줄 수 있으니 신중하게 수정하세요.<br />
        • 목록·상세 화면에 "삭제" 버튼이 노출되어 있지 않습니다.
      </GuideText>
    </GuideSection>
  </>
);

const TAB_CONTENT = {
  overview: OverviewGuide,
  fields: FieldsGuide,
  usage: UsageGuide,
  refund: RefundGuide,
};

const TicketGuideModal = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const TabContent = TAB_CONTENT[activeTab];

  return (
    <Modal open={open} onClose={onClose} disableScrollLock>
      <GuideModalContainer>
        <GuideModalHeader>
          <GuideModalHeaderTitle>수강권 가이드</GuideModalHeaderTitle>
          <IconButton onClick={onClose} sx={{ color: '#fff', p: '4px' }}>
            <Close />
          </IconButton>
        </GuideModalHeader>

        {/* 탭 */}
        <Box sx={{
          display: 'flex', borderBottom: '1px solid #e0e0e0', flexShrink: 0, backgroundColor: '#fafafa',
        }}>
          {TABS.map(tab => (
            <Box
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              sx={{
                flex: 1, textAlign: 'center', padding: '12px 0', cursor: 'pointer',
                fontSize: '13px', fontWeight: activeTab === tab.key ? 700 : 500,
                fontFamily: 'Pretendard, sans-serif',
                color: activeTab === tab.key ? '#4AB3BC' : '#888',
                borderBottom: activeTab === tab.key ? '2px solid #4AB3BC' : '2px solid transparent',
                transition: 'all 0.15s ease',
                '&:hover': { color: '#4AB3BC', backgroundColor: '#f0f8f8' },
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>

        <GuideModalBody>
          <TabContent />
        </GuideModalBody>
      </GuideModalContainer>
    </Modal>
  );
};

export default TicketGuideModal;
